import Tabs from '@storeblocks/tabs';
import { styled } from 'styled-components';

export const ConnectTabs = styled(Tabs)`
  > div {
    // Make the bottom border stretch
    width: 100%;
  }
`;
